export default __webpack_public_path__ + "static/media/alIconDark.5947d0a2.svg";